import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import LanguageLocaleSearch from "./LanguageLocaleSearch";
import LanguageLocaleTable from "./LanguageLocaleTable";
import '../modal.scss';
import LanguageLocaleCreate from "./LanguageLocaleCreate";
import {Slide, toast} from "react-toastify";

function LanguageLocales() {
    const [locales, setLocales] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingLocale, setEditingLocale] = useState(null);

    const fetchLocales = async (name) => {
        const baseUrl = `/languageLocales`;

        try {
            const response = await apiClient.get(baseUrl);
            if (!name) {
                setLocales(response.data.list);
                return;
            }

            const filteredLocales = response.data.list.filter(locale =>
                locale.name.toLowerCase().includes(name.toLowerCase())
            );
            setLocales(filteredLocales);
        } catch (error) {
            console.error('Error fetching locales:', error);
        }
    };

    useEffect(() => {
        fetchLocales();
    }, []);

    const search = async (name) => {
        fetchLocales(name);
    };

    const handleCreate = () => {
        setEditingLocale(null);
        setShowModal(true);
    };

    const handleEdit = (locale) => {
        setEditingLocale(locale);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/languageLocales/${id}`;

        try {
            await apiClient.delete(url);
            await fetchLocales();
        } catch (error) {
            console.error('Error deleting locale:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (localeData) => {
        const url = editingLocale ?
            `/languageLocales/${editingLocale.id}` :
            `/languageLocales`;

        try {
            if (editingLocale) {
                await apiClient.patch(url, localeData);
                toast.success('Language Locale updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, localeData);
                toast.success('Language Locale created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchLocales();
        } catch (error) {
            console.error('Error saving locale:', error);
        }
    };

    return (
        <div className="mainBody">
            <LanguageLocaleSearch onSearch={search} onCreate={handleCreate}/>
            <LanguageLocaleTable locales={locales} onEdit={handleEdit} onDelete={handleDelete}/>
            {showModal &&
                <LanguageLocaleCreate locale={editingLocale} onClose={handleCloseModal} onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default LanguageLocales;
